import _extends from"@babel/runtime/helpers/extends";var DEFAULTS=Object.freeze({type:"line-spacing",config:{}}),pluginLineSpacing=function(config){return{config:_extends({},DEFAULTS.config,config),type:"line-spacing"}};export{pluginLineSpacing};
//# sourceMappingURL=module.viewer.js.map
